import { errorReporter } from './error-reporter';
/**
 * 基础结算错误类
 */
export class CustomerError extends Error {
    constructor(type, message, metadata) {
        super(message);
        this.reported = false;
        this.name = 'CustomerError';
        this.type = type;
        this.timestamp = new Date();
        this.metadata = metadata || {};
        // 保持正确的原型链
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CustomerError);
        }
    }
    /**
     * 序列化错误信息（用于日志上报）
     */
    toJSON() {
        return {
            type: this.type,
            name: this.name,
            message: this.message,
            timestamp: this.timestamp.toISOString(),
            metadata: this.metadata
        };
    }
    // 自动上报方法
    report() {
        if (this.reported)
            return;
        errorReporter.captureException(this, Object.assign(Object.assign({}, this.metadata), { errorName: this.name, originalStack: this.stack, errorType: this.type, timestamp: this.timestamp.toISOString() }));
        this.reported = true;
        return this;
    }
    // 链式调用
    with(metadata) {
        Object.assign(this.metadata, metadata);
        return this;
    }
}
